// helpers for the TenantRoles a TenantUser holds (Oct 2026)
// TU objects from the API have `tenant_roles`: [{id, slug, name, description}] -- show `name`, match on `slug`


// built-in TenantRole slugs (the 'ext_' prefix is for roles held by external TUs)
const SOURCING_TENANT_ROLE_SLUG = 'ext_sourcing';
const QUALITY_TENANT_ROLE_SLUG = 'ext_quality';

const findTenantRole = (tuObj, slug) => {
    // the TenantRole object with this slug that the TU holds, or undefined
    return (tuObj?.tenant_roles || []).find(role => role.slug === slug);
};

const hasTenantRole = (tuObj, slug) => {
    return Boolean(findTenantRole(tuObj, slug));
};


export {
    SOURCING_TENANT_ROLE_SLUG,
    QUALITY_TENANT_ROLE_SLUG,
    findTenantRole,
    hasTenantRole,
}
